export const getAvatarLink = (fullLink: string): string => {
  if (!fullLink) return ""
  fullLink = fullLink.substring(1)
  return `${process.env.VUE_APP_API_URL}${fullLink}`
}
